<template>
  <div>
    <!-- 批量审核 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('home.batchReview')"
      :visible.sync="batchReviewDialog"
      width="580px"
    >
      <div>
        <div style="font-size: 16px; font-weight: bold">
          {{ $t('GlobalSetObj.totalOptions') }}: {{ selectDataList.length }}
        </div>
        <div style="margin-top: 20px">
          <el-radio-group v-model="auditsState" size="medium" @change="changeAuditsState">
            <el-radio-button :label="1">{{ $t('receivablePayable.Approved') }}</el-radio-button>
            <el-radio-button :label="0">{{ $t('orderCenterCont.ReviewFailed') }}</el-radio-button>
          </el-radio-group>
        </div>
        <div v-if="auditsState === 0" style="margin-top: 20px">
          <el-checkbox-group v-model="singeOrPhoto" size="medium">
            <el-checkbox-button :label="1">{{ $t('home.photoStandard') }}</el-checkbox-button>
            <el-checkbox-button :label="2">{{ $t('home.signStandard') }}</el-checkbox-button>
          </el-checkbox-group>
        </div>
      </div>
      <div style="text-align: right; margin: 10px 0">
        <el-button
          size="small" @click="batchReviewDialog = false"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button
          size="small" type="primary" @click="confirm"
        >{{ $t('GlobalSetObj.determine') }}
        </el-button>
      </div>
    </el-dialog>
    <!--  审核结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('home.reviewResult')"
      :visible.sync="auditResultDialog"
      width="580px"
    >
      <div class="flx-between" style="font-size: 16px">
        <div>
          {{ $t('home.operationTotal') }}:<span class="tipclass">{{
            resultsObj.operateTotal
          }}</span>
        </div>
        <div>
          {{ $t('operationCenter.NumberOfSuccesses') }}:<span class="tipclass">{{
            resultsObj.operateSuccesses
          }}</span>
        </div>
        <div>
          {{ $t('operationCenter.NumberOfFailures') }}:<span class="tipclass" style="color: red">{{
            resultsObj.operateFailures
          }}</span>
        </div>
      </div>
      <div
        v-if="resultsObj.operateFailures"
        style="
          margin-top: 15px;
          font-size: 16px;
          line-height: 30px;
          height: 200px;
          overflow-y: auto;
        "
      >
        <div>{{ $t('GlobalSetObj.ReasonForFailure') }}:</div>
        <div v-for="(item, index) in resultsObj.remindersDetailsVOList" :key="index">
          <span>{{ index + 1 }}.</span>
          <span>{{ item.reason }}</span>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <el-button
          size="small" type="primary" @click="auditResultDialog = false"
        >{{ $t('GlobalSetObj.determine') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { lgStorageForceSignBatchReview } from '@/api/orderApi';
import { Loading } from 'element-ui';

export default {
  data() {
    return {
      auditResultDialog: false,
      batchReviewDialog: false,
      resultsObj: {
        remindersDetailsVOList: []
      },
      auditsState: '', // 审核状态0 审核不通过 1审核通过
      singeOrPhoto: [],
      selectDataList: []
    };
  },
  methods: {
    changeAuditsState() {
      this.singeOrPhoto = [];
    },
    // 批量审核
    clickBatchReviewDialog(arr) {
      this.selectDataList = arr;
      this.auditsState = ''; // 审核状态0 审核不通过 1审核通过
      this.singeOrPhoto = [];
      this.batchReviewDialog = true;
    },
    confirm() {
      if (this.auditsState !== '') {
        const data = {
          idList: [],
          auditsState: this.auditsState,
          photoStandard: 1,
          signStandard: 1
        };
        if (this.auditsState === 0 && this.singeOrPhoto.length === 0) {
          this.$message.error(this.$t('home.tip1002'));
          return;
        }
        if (this.auditsState === 0 && this.singeOrPhoto.length === 1) {
          if (this.singeOrPhoto[0] === 1) {
            data.photoStandard = 0;
          } else {
            data.signStandard = 0;
          }
        }
        if (this.auditsState === 0 && this.singeOrPhoto.length === 2) {
          data.signStandard = 0;
          data.photoStandard = 0;
        }
        this.selectDataList.forEach((item) => {
          data.idList.push(item.id);
        });
        console.log(data, 'lgStorageForceSignBatchReview');
        // return;
        const load = Loading.service({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: this.$t('collectionCenter.loading'),
          background: 'rgba(250, 250, 250, 0.6)'
        });
        this.batchReviewDialog = false;
        lgStorageForceSignBatchReview(data)
          .then((res) => {
            if (res.code === 200) {
              load.close();
              console.log(res, 'lgStorageForceSignBatchReview');
              this.resultsObj = res.data;
              this.auditResultDialog = true;
              this.$emit('call-parent-method', false);
            }
          })
          .finally(() => {
            load.close();
          });
      } else {
        this.$message.error(this.$t('changepwd.selectResult'));
      }
    }
  }
};
</script>

<style scoped>
.warpContent {
  width: 100%;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 15px;
  border: 1px solid #ccc;
}

.signImageCss {
  font-size: 20px;
  font-weight: bold;
  color: #409eff;
  margin: 10px 0;
}
</style>
